import {DocumentRoleCapability} from "../../../common/enums/roles/capabilities/documentRoleCapability";
import Decorator from "../../../common/models/decorator";
import Capable from "../../../common/mixins/capable";
import {ICapable} from "../../../common/interfaces/capableInterfaces";

export default abstract class DocumentDecorator extends Capable(Decorator) implements ICapable {
  object: object;
  id: string;
  author: object;
  c_at: string;
  shares: { reference_id: string, capabilities: DocumentRoleCapability[] }[] = [];

  abstract get isPublished(): boolean;

  get publishedStatus(): string {
    return this.isPublished ? 'Published' : 'Unpublished';
  }
}